import axios from 'axios';
import { getToken, logout } from './auth';
import Swal from 'sweetalert2';

export const api = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL_BACKEND_API,
  withCredentials: true,
  timeout: 300000
});

export const apiUbots = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL_BACKEND_API_COOPERADOS,
});

api.interceptors.request.use(async (config) => {
  const token = getToken();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    switch (error.response.status) {
      case 401:
        Swal.fire({
          icon: 'error',
          title: 'Ocorreu um erro na autenticação: 401',
        });

        window.location.href = '/login';

        logout();

        return Promise.reject(error);
      case 403:
        if (window.location.pathname !== '/login') {
          setTimeout(() => {
            window.location.href = '/forbidden';
          }, 4000);
        }

        return Promise.reject(error);
      case 500:
        return Promise.reject(error);
    }
    return Promise.reject(error);
  },
);

export async function abrirCartaoPdf(bilheteId: number) {
  const url = `/cartao/${bilheteId}/pdf`;

  const win = window.open('', '_blank');

  if (!win) {
    console.error("Popup bloqueado pelo navegador");
    return;
  }

  try {
    const response = await api.get(url, { responseType: 'blob' });

    const pdfURL = URL.createObjectURL(response.data);
    win.location.href = pdfURL;
  } catch (e) {
    win.close();
    console.error("Erro ao abrir cartão de embarque", e);
  }
}

export async function abrirVoucherPdf(pedidoId: number) {
  const url = `/passagens/${pedidoId}/voucher`;

  const win = window.open('', '_blank');

  if (!win) {
    console.error("Popup bloqueado pelo navegador");
    return;
  }

  try {
    const response = await api.get(url, { responseType: 'blob' });

    const pdfURL = URL.createObjectURL(response.data);
    win.location.href = pdfURL;
  } catch (e) {
    win.close();
    console.error("Erro ao abrir voucher", e);
  }
}


export async function abrirFaturaPdf(faturaId: number | string) {
  const url = `/fatura/${faturaId}/pdf`;

  const win = window.open('', '_blank');

  if (!win) {
    throw new Error('popup_blocked');
  }

  try {
    win.document.title = 'Carregando fatura...';
    win.document.body.innerHTML = '<div style="font-family: Arial, sans-serif; padding: 24px; color: #333;">Carregando PDF da fatura, aguarde...</div>';

    const response = await api.get(url, { responseType: 'blob' });

    const pdfURL = URL.createObjectURL(response.data);
    win.location.href = pdfURL;
  } catch (e) {
    win.close();
    console.error("Erro ao abrir fatura", e);
    throw e;
  }
}

export async function abrirFaturaResumidaPdf(faturaId: number | string) {
  const url = `/fatura/${faturaId}/pdf-resumida`;

  const win = window.open('', '_blank');

  if (!win) {
    throw new Error('popup_blocked');
  }

  try {
    win.document.title = 'Carregando fatura resumida...';
    win.document.body.innerHTML = '<div style="font-family: Arial, sans-serif; padding: 24px; color: #333;">Carregando PDF resumido da fatura, aguarde...</div>';

    const response = await api.get(url, { responseType: 'blob' });

    const pdfURL = URL.createObjectURL(response.data);
    win.location.href = pdfURL;
  } catch (e) {
    win.close();
    console.error("Erro ao abrir fatura resumida", e);
    throw e;
  }
}

export async function abrirBoletoSicoobPdf(boletoId: number | string) {
  const url = `/boletos-sicoob/${boletoId}/pdf`;

  const win = window.open('', '_blank');

  if (!win) {
    throw new Error('popup_blocked');
  }

  try {
    win.document.title = 'Carregando boleto...';
    win.document.body.innerHTML = '<div style="font-family: Arial, sans-serif; padding: 24px; color: #333;">Carregando PDF do boleto, aguarde...</div>';

    const response = await api.get(url, { responseType: 'blob' });

    const pdfURL = URL.createObjectURL(response.data);
    win.location.href = pdfURL;
  } catch (e) {
    win.close();
    console.error("Erro ao abrir boleto Sicoob", e);
    throw e;
  }
}
